export default __webpack_public_path__ + "static/31509-f2d4f66769d7e87c683e89afd2f3d104.jpg";